<template>
  <div class="content">
    <div class="cardBox">
      <div class="title">
        <span class="left">{{ totalData.targetLevelOname }}</span>
        <el-select
          v-model="checkValue"
          placeholder="请选择"
          class="right"
          size="mini"
          @change="changeSelect"
        >
          <el-option
            v-for="item in optionList"
            :key="item.id"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
          <!-- <el-option label="流量点击" value="2"> </el-option>
          <el-option label="流量起播" value="3"> </el-option> -->
        </el-select>
      </div>
      <div class="ltem">
        <div class="left">
          <div
            class="leftList"
            v-for="(item, index) in overviewData"
            :key="index"
          >
            <h4>{{ item.title }}</h4>
            <p>{{ item.value }}</p>
          </div>
        </div>
        <div class="right">
          <div class="tags">
            <span
              :class="tagsType === 'all' ? 'active' : ''"
              @click="changeTags('all')"
            >全部</span>
            <span
              :class="tagsType === 'normal' ? 'active' : ''"
              @click="changeTags('normal')"
            >日常期</span>
            <span
              :class="tagsType === 'activity' ? 'active' : ''"
              @click="changeTags('activity')"
            >节点期</span>
          </div>
          <div
            id="container"
            ref="container"
            style="height: 280px; width: 440px"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  components: {},
  props: {
    // 总的数据
    totalData: {
      type: Object,
      default: () => ({})
    },
    // 左边的目标值
    overviewData: {
      type: Array,
      default: () => []
    },
    // 指标下拉框选项
    optionList: {
      type: Array,
      default: () => []
    },
    // 默认当前选中的指标
    defaultSelect: {
      type: String,
      default: ''
    },
    activitys: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentChoiceDate: '', // 当前选中的年月
      firstMouthDay: 0, // 当前月的第一天是周几
      mouthWeeks: 5, // 当前月有几周  默认5周
      currentMouthDays: 0, // 当前月总共有多少天
      mouthWeeksDays: [], // 当前月每周的开始时间及结束时间
      chart: null,
      tagsType: 'all',
      dom: null,
      baseObj: {
        title: {
          text: '',
          show: false
        },
        tooltip: {},
        legend: {
          left: 'right',
          icon: 'circle',
          textStyle: {
            color: '#fff'
          },
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: {},
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#777488',
              type: 'dashed'
            }
          }
        },
        series: []
      },
      dataMsg: [], // 通过接口查询返回的数据 是一整个月的数据
      weekActualValue: [],
      weekTargetValue: [],
      GAPvalue: [],
      tagweekActualValue: [],
      tagweekTargetValue: [],
      tagGAPvalue: [],
      checkValue: '', // 下拉选中项
      currentDate: new Date().getDate() - 1 // 当前月份的第几天
    }
  },
  computed: {},
  methods: {
    init (data) {
      this.weekActualValue = []
      this.weekTargetValue = []
      this.GAPvalue = []
      if (data) {
        this.checkValue = data
      }
      this.dataMsg = this.totalData.list
      this.dataMsg.forEach(item => {
        // 日实际值
        this.weekActualValue.push({
          value: item.actualValue,
          activitLs: item.activits,
          totalActualWeek: item.totalActualWeek,
          activityTotal: item.activityTotal
        })
        // 周目标值
        this.weekTargetValue.push({
          value: item.totalWeekAll,
          activitLs: item.activits,
          totalActualWeek: item.totalActualWeek,
          totalWeekNormal: item.totalWeekNormal,
          totalWeekActivity: item.totalWeekActivity,
          activityTotal: item.activityTotal
        })
        // GAP值
        this.GAPvalue.push({
          value: item.gap,
          activitLs: item.activits,
          totalActualWeek: item.totalActualWeek,
          activityTotal: item.activityTotal
        })
      })
      this.initCharts('all')
    },
    changeTags (type, data) {
      // TODO 拿到data的值进行处理 然后重新刷图表
      this.tagweekActualValue = []
      this.tagGAPvalue = []
      this.tagweekTargetValue = []
      this.tagsType = type
      if (type === 'all') {
        this.tagweekActualValue = this.weekActualValue
        this.tagweekTargetValue = this.weekTargetValue
      } else if (type === 'normal') {
        // 周目标值
        this.weekTargetValue.forEach(item => {
          this.tagweekTargetValue.push({
            activitLs: [],
            value: item.totalWeekNormal
          })
        })
        // 周实际值
        this.weekActualValue.forEach(item => {
          if (item.activitLs && item.activitLs.length > 0) {
            this.tagweekActualValue.push({
              activitLs: [],
              value: 0
            })
          } else {
            this.tagweekActualValue.push(item)
          }
        })
        // GAP
        this.GAPvalue.forEach(item => {
          if (item.activitLs && item.activitLs.length > 0) {
            this.tagGAPvalue.push({
              activitLs: [],
              value: 0
            })
          } else {
            this.tagGAPvalue.push(item)
          }
        })
      } else if (type === 'activity') {
        this.weekTargetValue.forEach(item => {
          this.tagweekTargetValue.push({
            activitLs: item.activitLs,
            value: item.totalWeekActivity,
            activityTotal: item.activityTotal
          })
        })
        this.weekActualValue.forEach(item => {
          if (item.activitLs && item.activitLs.length > 0) {
            this.tagweekActualValue.push(item)
          } else {
            this.tagweekActualValue.push({
              activitLs: [],
              value: 0
            })
          }
        })
        this.GAPvalue.forEach(item => {
          if (item.activitLs && item.activitLs.length > 0) {
            this.tagGAPvalue.push(item)
          } else {
            this.tagGAPvalue.push({
              activitLs: [],
              value: 0
            })
          }
        })
      }
      this.initCharts(type)
    },
    changeSelect () {
      this.tagsType = 'all'
      this.$emit('selectChange', this.checkValue, this.totalData.targetLevelOne)
    },
    formatData () {
      const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate')).time

      // 选中的年
      const choiceYear = choiceDate.split('-')[0]
      // 选中的月
      const choiceMonth = choiceDate.split('-')[1]
      var startDate = new Date(choiceDate)
      // 获取当前月份第一天是周几
      let day =
        parseInt(startDate.getDay()) === 0 ? 7 : parseInt(startDate.getDay())
      this.firstMouthDay = day
      // 判断当月有几周
      let days = new Date(choiceYear, choiceMonth, 0).getDate() // 获取当月总共天数
      this.currentMouthDays = days
      let y = days % 7
      var zhou = 0
      if (7 - day >= y) {
        zhou = parseInt(days / 7) + 1
      } else {
        zhou = parseInt(days / 7) + 2
      }
      let endDate = new Date(choiceDate + `-` + days).getDay()
      if (endDate === 0) {
        zhou = zhou - 1
      }
      this.mouthWeeks = zhou
      this.currentChoiceDate = choiceDate
      // 计算出当前月总共几周 每周的开始时间结束时间
      let arr = []
      for (let i = 0; i < zhou; i++) {
        if (i === 0) {
          arr.push({
            start: choiceDate + '-' + Number(i + 1),
            startI: Number(i + 1),
            end: choiceDate + '-' + (7 - day + 1 + 7 * i),
            endI: 7 - day + 1 + 7 * i
          })
        } else {
          arr.push({
            start: choiceDate + '-' + (7 - day + 1 + 7 * i + 1 - 7),
            startI: 7 - day + 1 + 7 * i + 1 - 7,
            end:
              choiceDate +
              '-' +
              (7 - day + 1 + 7 * i > days ? days : 7 - day + 1 + 7 * i),
            endI: 7 - day + 1 + 7 * i > days ? days : 7 - day + 1 + 7 * i
          })
        }
      }
      this.mouthWeeksDays = arr
    },
    initCharts (type) {
      // this.baseObj.legend.data = ['周目标值', '日实际值', 'GAP值']
      this.baseObj.legend = {
        type: 'plain',
        right: 10,
        icon: 'circle',
        itemWidth: 12,
        data: ['周目标值', '日实际值', '日GAP值'],
        itemGap: 10,
        textStyle: {
          fontSize: 10,
          color: '#fff'
        },
        selected: {
          '周目标值': true,
          '日实际值': true,
          '日GAP值': false
        }
      }
      this.baseObj.xAxis = {
        type: 'category',
        splitLine: {
          show: false
        },
        boundaryGap: true,
        axisTick: {
          show: true // false 不显示X轴刻度
        },
        axisPointer: {
          type: 'none',
          label: {
            show: false, // false 不显示鼠标移上去X轴数字，
            formatter: function (params) {
              return params.value
            }
          }
        },
        axisLabel: {
          interval: 0,
          formatter: (value, index) => {
            let surplus = 7 - this.firstMouthDay + 1 // 第一周还剩几天
            if (Number(value) === 0) {
              return '第一周'
            } else if (Number(value) === surplus) {
              return '第二周'
            } else if (Number(value) === surplus + 8) {
              return '第三周'
            } else if (Number(value) === surplus + 15) {
              return '第四周'
            } else if (Number(value) === surplus + 22) {
              return '第五周'
            } else if (Number(value) === surplus + 29) {
              return '第六周'
            } else {
              return ''
            }
          }
        }
      }

      this.baseObj.tooltip = {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderColor: 'rgba(0, 0, 0, 0.8)',
        textStyle: {
          color: '#fff',
          fontSize: 12
        },
        extraCssText: 'width: 200px',
        formatter: params => {
          let surplus = 7 - this.firstMouthDay + 1 // 第一周还剩几天
          // console.log(params)
          let str = ''
          for (let n in params) {
            str = `<div style="font-size:12px;">当前：${this.currentChoiceDate}-${params[n].dataIndex + 1}</div>`
            if (params[n].dataIndex + 1 <= surplus) {
              str += `<div style="font-size:12px;">
                第一周 (${this.currentChoiceDate}-1 至 ${this.currentChoiceDate}-${surplus})</div>`
              if (params[n].seriesName === '周目标值') {
                if (params[n].data.activitLs.length > 0) {
                  params[n].data.activitLs.forEach(item => {
                    str += `<div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                      <div>活动目标值：<span>${item.nodeTargetValue}</span></div>`
                  })
                }
              } else if (params[n].seriesName === '日实际值') {
                str += `<div>周实际值：<span>${
                  params[n].data.totalActualWeek || 0
                }</span></div>`
              }
            } else if (
              params[n].dataIndex + 1 > surplus &&
              params[n].dataIndex + 1 <= surplus + 7
            ) {
              str += `<div style="font-size:12px;">第二周 (${
                this.currentChoiceDate}-${surplus + 1} 至 ${this.currentChoiceDate}-${
                surplus + 7})</div>`
              if (params[n].seriesName === '周目标值') {
                if (params[n].data.activitLs.length > 0) {
                  params[n].data.activitLs.forEach(item => {
                    str += `
                      <div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                      <div>活动目标值：<span>${item.nodeTargetValue}</span></div>
                    `
                  })
                }
              } else if (params[n].seriesName === '日实际值') {
                str += `<div>周实际值：<span>${
                  params[n].data.totalActualWeek || 0
                }</span></div>`
              }
            } else if (
              params[n].dataIndex + 1 > surplus + 7 &&
              params[n].dataIndex + 1 <= surplus + 14
            ) {
              str += `<div style="font-size:12px;">第三周 (${
                this.currentChoiceDate}-${surplus + 8} 至 ${this.currentChoiceDate}-${surplus + 14})</div>`
              if (params[n].seriesName === '周目标值') {
                if (params[n].data.activitLs.length > 0) {
                  params[n].data.activitLs.forEach(item => {
                    str += `
                      <div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                      <div>活动目标值：<span>${item.nodeTargetValue}</span></div>`
                  })
                }
              } else if (params[n].seriesName === '日实际值') {
                str += `<div>周实际值：<span>${
                  params[n].data.totalActualWeek || 0
                }</span></div>`
              }
            } else if (
              params[n].dataIndex + 1 > surplus + 14 &&
              params[n].dataIndex + 1 <= surplus + 21
            ) {
              str += `
                <div style="font-size:12px;">第四周 (${this.currentChoiceDate}-${surplus + 15} 至 ${this.currentChoiceDate}-${surplus + 21})</div>`
              if (params[n].seriesName === '周目标值') {
                if (params[n].data.activitLs.length > 0) {
                  params[n].data.activitLs.forEach(item => {
                    str += `
                      <div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                      <div>活动目标值：<span>${item.nodeTargetValue}</span></div>
                    `
                  })
                }
              } else if (params[n].seriesName === '日实际值') {
                str += `<div>周实际值：<span>${
                  params[n].data.totalActualWeek || 0
                }</span></div>`
              }
            } else if (
              params[n].dataIndex + 1 > surplus + 21 &&
              params[n].dataIndex + 1 <= surplus + 28
            ) {
              if (surplus + 28 <= 31) {
                str += `<div style="font-size:12px;">第五周 (${
                  this.currentChoiceDate}-${surplus + 22} 至 ${this.currentChoiceDate}-${surplus + 28
                })</div>`

                if (params[n].seriesName === '周目标值') {
                  if (params[n].data.activitLs.length > 0) {
                    params[n].data.activitLs.forEach(item => {
                      str += `
                        <div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                        <div>活动目标值：<span>${item.nodeTargetValue}</span></div>
                      `
                    })
                  }
                } else if (params[n].seriesName === '日实际值') {
                  str += `<div>周实际值：<span>${
                    params[n].data.totalActualWeek || 0
                  }</span></div>`
                }
              } else {
                str += `<div style="font-size:12px;">第五周 (${
                  this.currentChoiceDate
                }-${surplus + 22} 至 ${this.currentChoiceDate}-${
                  this.currentMouthDays
                })</div>`

                if (params[n].seriesName === '周目标值') {
                  if (params[n].data.activitLs.length > 0) {
                    params[n].data.activitLs.forEach(item => {
                      str += `
                        <div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                        <div>活动目标值：<span>${item.nodeTargetValue}</span></div>
                      `
                    })
                  }
                } else if (params[n].seriesName === '日实际值') {
                  str += `<div>周实际值：<span>${
                    params[n].data.totalActualWeek || 0
                  }</span></div>`
                }
              }
            } else if (
              params[n].dataIndex + 1 > surplus + 28 &&
              params[n].dataIndex + 1 <= 31
            ) {
              str += `
                <div style="font-size:12px;">第六周 (${this.currentChoiceDate}-${surplus + 29} 至 ${this.currentChoiceDate}-${this.currentMouthDays})</div>
                `
              if (params[n].seriesName === '周目标值') {
                if (params[n].data.activitLs.length > 0) {
                  params[n].data.activitLs.forEach(item => {
                    str += `
                      <div>${item.nodeName}(${item.nodeStart}至${item.nodeEnd})</div>
                      <div>活动目标值：<span>${item.nodeTargetValue}</span></div>
                    `
                  })
                }
              } else if (params[n].seriesName === '日实际值') {
                str += `<div>周实际值：<span>${
                  params[n].data.totalActualWeek || 0
                }</span></div>`
              }
            }
          }

          for (let x in params) {
            if (this.checkValue === 'payrate' || this.checkValue === 'retention_one' || this.checkValue === 'retention_seven') {
              str += `
              <div style="display:flex;align-items:center;justify-content: space-between"><span>${params[x].seriesName}</span>  <span>${params[x].data.value}%</span></div>
              `
            } else {
              str += `
              <div style="display:flex;align-items:center;justify-content: space-between"><span>${params[x].seriesName}</span>  <span>${params[x].data.value}</span></div>
              `
            }
          }

          return str
        }
      }

      this.baseObj.series = [
        {
          name: '周目标值',
          type: 'line',
          data: this.weekTargetValue,
          showSymbol: false,
          markLine: {
            symbol: ['none', 'none'],
            label: { show: false },
            data: [{ xAxis: this.currentDate }]
          },
          markArea: {
            itemStyle: {
              color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
          },
          itemStyle: {
            normal: {
              lineStyle: {
                width: 2,
                type: 'dotted'
              }
            }
          }
        },
        {
          name: '日实际值',
          type: 'line',
          data: this.weekActualValue,
          showSymbol: false,
          markArea: {
            itemStyle: {
              color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
          }
        },
        {
          name: '日GAP值',
          type: 'line',
          data: this.GAPvalue,
          showSymbol: false,
          markArea: {
            itemStyle: {
              color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
          }
        }
      ]

      if (type === 'all') {
        this.activitys.forEach(item => {
          this.baseObj.series[0].markArea.data.push([
            {
              name: item.nodeName,
              xAxis: Number(item.sday),
              label: {
                color: '#fff',
                backgroundColor: 'none'
              }
            },
            {
              xAxis: Number(item.eday)
            }
          ])
        })
        this.baseObj.series[1].data = this.weekActualValue
        this.baseObj.series[2].data = this.GAPvalue
      } else {
        this.baseObj.series[0].markArea.data = []
        this.baseObj.series[0].data = this.tagweekTargetValue
        this.baseObj.series[1].data = this.tagweekActualValue
        this.baseObj.series[2].data = this.tagGAPvalue
      }
      this.chart.hideLoading()
      this.chart.setOption(this.baseObj)
    }
  },
  watch: {},
  created () {
    this.formatData()
  },

  mounted () {
    this.dom = this.$refs.container
    this.chart = echarts.init(this.dom)
    this.chart.showLoading({
      text: '加载中...',
      color: '#1c76fd',
      textColor: '#1c76fd',
      maskColor: 'rgba(0, 0, 0, 0.1)',
      zlevel: 9990
    })
  }
}
</script>

<style lang="stylus" scoped>
.cardBox {
  .title {
    background: #1f1e44;
    line-height: 50px;
    height: 50px;
    font-size: 0.9rem;
    color: #fff;
    padding: 0 1.5rem;
    border-radius: 0.5rem 0.5rem 0 0;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
    .right {
      color: rgba(255,255,255,0.8);
      line-height: 1.2rem;
      padding: 0 0.5rem;
      border-radius: 0.3rem;
      display: inline-block;
      cursor: pointer;
      position: relative;
      font-size 14px
    }
  }
}
.ltem {
  display: flex;
  width: 600px;
  align-items: center;
  background: #1c1839;
  border-radius: 0 0 0.5rem 0.5rem;
  .left {
    width: 150px;
    .leftList {
      color: #fff;
      margin-left:14px;
      h4 {
        font-size: 13px;
      }
      p {
        margin-top: 8px
        font-size: 18px
        margin-bottom: 30px
      }
    }
  }
  .right {
    position: relative;
    .tags {
      position: absolute;
      left: 10px;
      top: 10px;
      color: #fff;
      font-size: 13px;
      z-index: 999;
      span {
        display: inline-block
        background rgba(24, 144, 255, 0.2)
        padding 6px 12px
        border-radius 4px
        margin-right 10px
        cursor pointer
        &.active {
          background: #1C76FD;
        }
      }
    }
    #container {
      margin-top: 10px;
    }
  }
}

.list {
  margin-top: 30px;
  .item {
    display: flex;
    margin-bottom: 16px
    .item_box {
      color: #fff;
    }
    &.border {
      padding-bottom: 16px
      border-bottom: 1px solid #777488
    }
    div {
      width: 33%
    }
  }

  .addBottomBtn {
    text-align: center;
    margin-top: 20px;
  }
}

::v-deep .el-input__inner {
  background: #1C1839;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.4)
}
::v-deep .el-input.is-disabled .el-input__inner {
  background: #322f4c;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.4)
}
::v-deep .el-range-input {
  background: #1C1839;
  color: #FFFFFF;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
//弹框头部
::v-deep .el-dialog__header {
    background: #1C1839;
    .el-dialog__title {
      color: #FFFFFF;
      font-size: 18px;
    }
}
//弹框标题
::v-deep .el-dialog__title {
    background: #1C1839;
}
::v-deep .el-dialog__footer {
  background: #1C1839;
}
//弹框内容部分
::v-deep .el-dialog__body {
  background: #1C1839;
  padding-top: 20px;
  .topSetTitle {
    color: #fff;
  }
}
</style>
